module.exports = __webpack_public_path__ + "static/img/tune.0d431243.svg";